
(function () {
  var root = document.documentElement;
  
  
  
  if (typeof sync === 'undefined') { var sync = function () {}; }   // public build: the sticky block above is gone, nothing to sync

  var lb = document.getElementById('lb');
  var thumbs = [].slice.call(document.querySelectorAll('.gt')), cover = document.getElementById('heroCover');
  if (lb && thumbs.length) {
    var img = document.getElementById('lbImg'), cap = document.getElementById('lbCap'), view = document.getElementById('lbView'), zb = document.getElementById('lbZoom');
    var items = [cover].concat(thumbs), cur = 0, i = 0, opener = null;
    var gi = document.getElementById('galImg'), gm = document.getElementById('galMain'), gc = document.getElementById('galCap');
    var select = function (n) {
      cur = n; var t = thumbs[n];
      gi.src = t.dataset.full; gi.alt = t.dataset.alt; gm.href = t.dataset.full;
      gc.innerHTML = ''; var b = document.createElement('b'), s = document.createElement('span'); b.textContent = t.dataset.title; s.textContent = t.dataset.sub; gc.appendChild(b); gc.appendChild(s);
      thumbs.forEach(function (x) { x.removeAttribute('aria-current'); }); t.setAttribute('aria-current', 'true');
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function (e) { e.preventDefault(); select(n); }); });
    var fit = function () { view.classList.remove('zoom'); zb.textContent = 'Zoom in'; zb.setAttribute('aria-pressed', 'false'); view.scrollTop = 0; view.scrollLeft = 0; };
    var show = function (n) {
      fit(); i = (n + items.length) % items.length; var it = items[i];
      img.src = it.dataset.full || it.getAttribute('href'); img.alt = it.dataset.alt || '';
      cap.textContent = (it.dataset.title || '') + (it.dataset.sub ? '. ' + it.dataset.sub : '');
    };
    var open = function (n, from) { opener = from; show(n); if (lb.showModal) lb.showModal(); else lb.setAttribute('open', ''); sync(); };
    cover.addEventListener('click', function (e) { e.preventDefault(); open(0, cover); });
    gm.addEventListener('click', function (e) { e.preventDefault(); open(cur + 1, gm); });
    zb.onclick = function () { var z = view.classList.toggle('zoom'); zb.textContent = z ? 'Fit page' : 'Zoom in'; zb.setAttribute('aria-pressed', z ? 'true' : 'false'); };
    lb.addEventListener('close', function () { fit(); if (i > 0) select(i - 1); sync(); if (opener) opener.focus(); });
    document.getElementById('lbClose').onclick = function () { lb.close(); };
    document.getElementById('lbPrev').onclick = function () { show(i - 1); };
    document.getElementById('lbNext').onclick = function () { show(i + 1); };
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb__in')) lb.close(); });
    document.addEventListener('keydown', function (e) { if (!lb.open) return; if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
  }

  function openHash() { var el = location.hash.length > 1 && document.getElementById(location.hash.slice(1)); if (el && el.tagName === 'DETAILS') el.open = true; }
  [].forEach.call(document.querySelectorAll('a[href="#faq-use"]'), function (l) { l.addEventListener('click', function () { var el = document.getElementById('faq-use'); if (el) el.open = true; }); });
  window.addEventListener('hashchange', openHash); openHash();
  
})();

// Genie product: real cart forms. One add per press: disable on submit, re-enable if the page is restored from bfcache.
(function () {
  var forms = [].slice.call(document.querySelectorAll('form[data-gp-form]'));
  var busy = false;
  forms.forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      busy = true;
      forms.forEach(function (g) { var b = g.querySelector('[data-gp-buy]'); if (b) { b.setAttribute('aria-busy', 'true'); setTimeout(function () { b.disabled = true; }, 0); } });
    });
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; busy = false;
    forms.forEach(function (g) { var b = g.querySelector('[data-gp-buy]'); if (b) { b.disabled = false; b.removeAttribute('aria-busy'); } });
  });
})();
